import { defineCollection } from "@rebasepro/cms-types";
import { SAY } from "../words";

// The raw usage log (songbuzz_events): what happened, on which page and device, in which room, with its details. No
// cookies and no lasting id. Kept a year (the retention cron). Games and Game songs are built from it.
// backend/functions/songbuzz.ts creates and writes it (POST /track).
const eventsCollection = defineCollection({
    name: "Events",
    singularName: "Event",
    slug: "events",
    table: "songbuzz_events",
    description: "The raw log of everything the pages report: views, games, rounds, sign-ups, errors. Kept a year.",
    securityRules: [{ operation: "select", roles: ["admin"] }],
    properties: {
        id: { name: "Event", type: "number", isId: true, columnType: "bigserial", admin: { readOnly: true } },
        at: { name: "When", type: "date", autoValue: "on_create", validation: { required: true }, admin: { readOnly: true } },
        kind: { name: "What happened", type: "string", validation: { required: true }, admin: { readOnly: true, Preview: "../../admin/src/previews/Words", customProps: { say: "event" } } },
        page: { name: "Page", type: "string", admin: { readOnly: true, Preview: "../../admin/src/previews/Words", customProps: { say: "page" } } },
        room: { name: "Room", type: "string", admin: { readOnly: true } },
        dev: { name: "Device", type: "string", admin: { readOnly: true, Preview: "../../admin/src/previews/Words", customProps: { say: "device" } } },
        lang: { name: "Language", type: "string", admin: { readOnly: true, Preview: "../../admin/src/previews/Words", customProps: { say: "language" } } },
        // a random id per page load, so the events of one visit can be put together; it says nothing about who
        sid: { name: "Visit", type: "string", admin: { readOnly: true, hideFromCollection: true } },
        props: { name: "Details", type: "map", keyValue: true, properties: {}, columnType: "jsonb", admin: { readOnly: true, span: 4, Preview: "../../admin/src/previews/EventDetails" } },
    },
    admin: {
        icon: "Activity",
        group: "System",
        openEntityMode: "side_panel",
        sort: ["at", "desc"],
        display: {
            title: ({ entity }) => SAY.event(entity.values.kind),
            subtitle: ({ entity }) => [SAY.page(entity.values.page), entity.values.room && `room ${entity.values.room}`, SAY.device(entity.values.dev), entity.values.lang && SAY.language(entity.values.lang)].filter(Boolean).join(" · ") || undefined,
            date: "at",
        },
        form: {
            sections: [
                { key: "event", properties: ["kind", "at", "page", "room", "dev", "lang", "props"] },
                { key: "ids", title: "Behind the scenes", collapsed: true, properties: ["id", "sid"] },
            ],
        },
    },
});

export default eventsCollection;
